<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="receivingListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
    >
      <vxe-table-column type="seq" title="序号" width="100">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{$rowIndex + 1}}</span>
          <Dropdown trigger="click" style="margin-left: 20px;" transfer>
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left:70px;">
              <div style="display: flex;flex-direction: column;">
                <Button class="button-gengduo" @click="confirmEvent(row.id)">移除结算信息</Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="receiveNum" title="结算确认编号" width="140" show-overflow>
        <template slot-scope="{ row }">
          <span
            @click="openReceivingDeail(row)"
            style="cursor:pointer;color: #2d8cf0;"
          >{{ row.receiveNum }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="addTime" title="结算时间" min-width="100"></vxe-table-column>
      <vxe-table-column field="goodsName" title="货品名称" min-width="100"></vxe-table-column>
      <vxe-table-column field="goodsRule" title="规格" min-width="100"></vxe-table-column>
      <vxe-table-column field="goodsUnit" title="单位" min-width="100"></vxe-table-column>
      <vxe-table-column field="counts" title="实际交接数量" min-width="120"></vxe-table-column>
      <vxe-table-column field="price" title="单价(元)" min-width="100"></vxe-table-column>
      <vxe-table-column field="receAmount" title="结算金额(元)" min-width="100">
        <template slot-scope="{ row }">
          <span>{{row.receAmount | formatMoney}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="note" title="摘要" min-width="100"></vxe-table-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager>
    <vxe-modal v-model="receivingDeailModal" width="1400"  height="700"
      position="center" title="托运人货物交接结算确认" showFooter>
      <p slot="title" class="box-tit-211130">
        <span>托运人货物交接结算确认</span>
      </p>
      <buyer-receiving-detail ref="receivingDetail" @closeRec="closeRec"></buyer-receiving-detail>
      <div slot="footer">
          <vxe-button
            type="submit"
            status="primary"
            @click="editReceiving(editRows)"
            v-if="isHavePermission('receiving:updateBuyerReceiveGoods')"
            style="width:140px;border-radius: 0px;"
          >编辑</vxe-button>
        </div>
    </vxe-modal>
    <edit-buyer-receiving ref="editReceiving" @updateList="updateList"></edit-buyer-receiving>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { numberToCurrency } from "@/filters/type";
import BuyerReceivingDetail from "@/views/receiving/BuyerReceivingDetail";
import EditBuyerReceiving from "@/views/receiving/EditBuyerReceiving";
import { isEmpty } from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";


export default {
  props: {
    id: String,
    pageTab: String
  },
  components: {
    BuyerReceivingDetail,EditBuyerReceiving
  },
  mixins: [getAuthOrization],

  data() {
    return {
      editRows:{},
      loading: false,
      receivingDeailModal: false,

      receivingListData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      amount: {
        totalRealCounts: 0,
        totalReceAmount: 0,
      },
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getReceivingListData();
    //   }
    // },
    pageTab() {
        this.pageTab === "tab3" ? this.init() : ''
      }
  },
  // activated() {
  //   // this.getReceivingListData();
  //   this.$bus.$on("orderDetailRenovate", (data) => {
  //     data === true ? this.getReceivingListData() : ''
  //   });
  // },
  methods: {
    init() {
      this.page.currentPage = 1
      this.getReceivingListData()
    },
    async getReceivingListData() {
      if (isEmpty(this.id)) return;
      this.loading = true;
      let res = await $api.receiving.request("queryBuyerReceiveGoodsListSelect", {
        ordersId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        isDesc:1,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.amount.totalRealCounts = res.data.countRtnVo.totalRealCounts;
        this.amount.totalReceAmount = res.data.countRtnVo.totalReceAmount;
        let receivingListData = res.data.rows;
        receivingListData.map((i) => {
          i.addTime = timeFormatDate(i.addTime);
          i.price = numberToCurrency(i.price);
          // i.receAmount = numberToCurrency(i.receAmount);
        });
        this.receivingListData = receivingListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    updateList(val){
      if(val){
          this.receivingDeailModal = false;
        this.getReceivingListData();
      }
    },
    openReceivingDeail(row) {
      if (!this.isHavePermission('buyer:ReceDetail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.editRows = row;
      this.receivingDeailModal = true;
      // this.getReceivingDetail(row);
      this.$refs.receivingDetail.getReceivingDetail(row);
    },
    async removeReceive(resdata) {
      let res = await $api.receiving.request(
        "updateBuyerReceiveGoods",
        resdata
      );
      if (res.status === 1) {
        this.$XModal.message({ message: `删除成功！` });
        this.getReceivingListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },

    async confirmEvent(id) {
      let res = await $api.receiving.request("queryBuyerReceiveGoodsDetail", {
        id,
      });
      this.$XModal
        .confirm("删除后，将解除此订单关联的结算信息", "是否删除此结算信息？")
        .then((type) => {
          // this.$XModal.message({ message: `点击了 ${type}` });
          if (type === "confirm") {
            if (res.status === 1) {
              var resdata = {};
              resdata = res.data;
              resdata.logisticsList = [];
              resdata.ordersBuyerId = null;
              var fileList = [];
              if (resdata.fileList != null) {
                resdata.fileList.map((i) => {
                  fileList.push(i.uuid);
                });
                resdata.fileUuidList = fileList;
              }
              this.removeReceive(resdata);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          }
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getReceivingListData();
    },
    closeRec(val) {
      this.receivingDeailModal = val;
    },
    editReceiving(row) {
      this.receivingDeailModal = false;
      this.$refs.editReceiving.editReceiving(row);

    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "单页合计";
          }
          if (["counts"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          if (["receAmount"].includes(column.property)) {
            return numberToCurrency(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "全部合计";
          }
          if (["counts"].includes(column.property)) {
            return this.amount.totalRealCounts;
          }

          if (["receAmount"].includes(column.property)) {
            return numberToCurrency(this.amount.totalReceAmount);
          }
          return null;
        }),
      ];
    },
  },
};
</script>

<style>
</style>